export const FETCH_OTHERMEDIA_INFO = "FETCH_OTHERMEDIA_INFO"
export const FETCH_OTHERMEDIA_INFO_SUCCESS = "FETCH_OTHERMEDIA_INFO_SUCCESS"

